module.exports = __webpack_public_path__ + "static/media/bg01.14691cac.jpg";